export const OTHER_TEMPLATE_CATEGORY = 'Other Forms'
export const TEMPLATE_CATEGORIES = [
  'Survey',
  'Lead Generation',
  'Customer Support',
  'Feedback',
  'Employee/Job',
  'Booking & Order',
  'Marketing',
  'Registration',
  'Education',
  'Event',
  'Healthcare',
  'Application',
  'Questionnaire & Quiz',
  'Remote Working',
  'Contact',
  'Business',
  'COVID-19',
  'Poll',
  'Request',
  'Banking & Finance',
  'Donation & Charity'
]
export const TEMPLATE_CATEGORY_DESCRIPTIONS: Record<string, string> = {
  Survey:
    'Build a survey form to get opinion from customer, employee or public. Simply pick one of our survey templates or create your own survey form from scratch.',
  'Lead Generation':
    'Create a lead generation form to collect data from your customers. Simply pick one of our lead generation templates or build your own form from blank.',
  'Customer Support':
    'Easily create your customer support form by either picking from one of our customer support form templates or create a customer support form from scratch.',
  Feedback:
    'Every successful business have one thing in common they depend on feedback. Be sure to get proper feedback, choose from our feedback form templates to create.',
  'Employee/Job':
    'Build your Employee/Job application form by either picking from one of our Employee/Job application form templates or create a application form from scratch.',
  'Booking & Order':
    'Are you looking for an online form builder to create booking forms? Our booking form templates will be ideal for you. Create your own booking form from blank. ',
  Marketing:
    'HeyForm event feedback form, customer survey, market research, and lead generation form templates are premade, pick one of them to create your own form.',
  Registration:
    'HeyForm registration form templates are easy to customize and edit with few clicks or you can create your own registration form from scratch.',
  Education:
    'Evaluate the performance of teachers, enroll students, conduct exams and gather feedbacks with HeyForm education form templates.',
  Event:
    'Conducting an event takes time and requires lot of items. With HeyForm event form templates, slice your time by creating your own event form online & share it.',
  Healthcare:
    'Are you searching for online healthcare form templates? HeyForm makes it easy for you with the healthcare form templates to register patients and get feedback.',
  Application:
    'Create elegant interactive application form by either picking from one of our application form templates or create a application form from scratch.',
  'Questionnaire & Quiz':
    'We know your valuable time. With HeyForm, you can pick from one of our premade questionnaire & quiz templates to create your own questionnaire & quiz form.',
  'Remote Working':
    'Now it is easy to track employees while working remotely with our free remote working tracking form templates.',
  Contact:
    'Prepare your contact form by either picking from one of our contact form templates or creating a contact form from scratch.',
  Business:
    'Are you looking for a free online form to collect money online? Its easy to sell your products and services with HeyForm premade business form templates.',
  'COVID-19':
    'Create COVID form from our COVID form templates and support those patients who have been hit hardest. Collect donations and medical data.',
  Poll: 'Are you looking for poll templates to create a poll and conduct with your customers? Your search ends with HeyForm, we have poll templates select from them.',
  Request:
    'Is your organization looking for the easiest way to field requests? Well. Thanks to HeyForm request forms templates, you will manage inquiries with ease.',
  'Banking & Finance':
    'Pick a free template from Banking & Finance Application Form templates and process applications for credit cards, debit cards, and much more.',
  'Donation & Charity':
    'HeyForm has templates for fundraising forms, volunteer application forms, donation & charity forms & more. Easily collect donations from these templates.'
}
